export { default as InputPassword } from './InputPassword'
